import React from "react";
import { Wifi, Flame, Bath, Car, Utensils, Tv, Snowflake, Mountain, UtensilsCrossed } from "lucide-react";
import { SectionHeader } from "./SectionHeader";
import { useT } from "@/lib/i18n";

const iconMap = { wifi: Wifi, flame: Flame, bath: Bath, car: Car, utensils: Utensils, tv: Tv, snow: Snowflake, mountain: Mountain, grill: UtensilsCrossed };

export const Amenities = () => {
  const { t } = useT();
  return (
    <section id="vybavenie" className="section-y bg-secondary/40" aria-labelledby="vybavenie-title">
      <div className="container-x">
        <SectionHeader kicker={t.amenitiesSection.kicker} title={t.amenitiesSection.title} subtitle={t.amenitiesSection.subtitle} />

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4" data-testid="amenities-grid">
          {t.amenities.map((a) => {
            const Icon = iconMap[a.icon] || Wifi;
            return (
              <div
                key={a.label}
                className="flex items-center gap-3 rounded-xl border border-border bg-card px-4 py-3.5 text-sm text-foreground shadow-soft"
                data-testid={`amenity-${a.icon}`}
              >
                <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg" style={{ background: "hsl(var(--pine))", color: "hsl(var(--primary-foreground))" }} aria-hidden>
                  <Icon className="h-4 w-4" />
                </span>
                <span className="font-medium">{a.label}</span>
              </div>
            );
          })}
        </div>

        <div id="preco" className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {t.whyUs.map((w, idx) => (
            <article key={idx} className="rounded-2xl border border-border bg-card p-6 shadow-soft" data-testid={`why-us-${idx}`}>
              <div className="kicker">0{idx + 1}</div>
              <h3 className="mt-2 font-display text-xl font-semibold text-foreground">{w.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground/80">{w.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
